/*eslint-disable*/
import React from 'react';
import PinFormComponent from './PinForm';
export default function addPins() {
  return <PinFormComponent />;
}
